import { Column, G2} from '@ant-design/plots';
import React, { useEffect,useState } from 'react';

const CustomBarChart = (props:any) => {
	const [barChartData, setBarChartData] =  useState<any[]>([]);
	const [barChartColors, setBarChartColors] =  useState<any[]>([]);
	G2.registerInteraction('element-highlight-by-x', {
		start: [{ trigger: 'element:mouseenter', action: 'element-highlight-by-x:highlight' }],
		end: [{ trigger: 'element:mouseleave', action: 'element-highlight-by-x:reset' }],
	});

	useEffect(() => {
        let originalData:any[] =props?.data;
		originalData = originalData.map((element:any)=>{
			element.value = parseFloat(element?.value);
			
			return element;
		})
		originalData.sort(function(a, b) {
			return Number(a.order) - Number(b.order);
		});
		let colors = originalData.map((element:any)=>{
			return element?.color;
		}).filter((v:any, i:any, a:any) => a.indexOf(v) === i);

		//update color with new value
		for (var i = 0; i < colors.length; i++) {
			if (colors[i] == "#f0f0f0") {
				colors[i] = "#8f9295"; 
				break;
			}
		}

		setBarChartColors(colors);
		setBarChartData(originalData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

	const getValue = (value:any,decimal:any=2)=>{
		let regexp = /\B(?=(\d{3})+(?!\d))/g;
		value = !isNaN(parseFloat(value))?value:0;
		value = parseFloat(value).toFixed(decimal).toString().replace(/\./g, ',')
		value = value.toString().replace(regexp, " ");
		return value;
	}

	const config:any = {
		data: barChartData,
		isStack: true,
		legend: {
			custom: true,
			position: 'top-left',
			pageNavigator:false,
			layout: 'horizontal',
			flipPage:false,
			items:[
				{
					name: 'Kuluoikaisut',
					marker: {symbol:'square', style:{fill:"#bfbfbf"}}
				},
				{
					name: 'Tuotot (pl. remonttilimiitit)',
					marker: {symbol:'square',style:{fill:"#81ffb8"}}
				},
				{
					name: 'Kulut (pl. urakat ja kuluoikaisut)',
					marker: {symbol:'square',style:{fill:"#8f9295"}}
				},
				{
					name: 'Urakkakulut ja -suoritukset',
					marker: {symbol:'square',style:{fill:"#00bcd4"}}
				}
			],
		},
		xField: 'yearMonth',
		yField: 'value',
		seriesField: 'type',
		style: { 
			color:"#fff"
		},
       	color:barChartColors,
		autofit:"height",
		tooltip: {
			showMarkers: false,
			formatter: (item:any,index:any) => {
				return { name: item.type, value: getValue(item.value,1)};
			},
		},
		theme: {
			"components": {
				"axis": {
					"common": {
						"label": {
							"style": {
								"fontSize": 7,
								"fill": "#000",
								"fontWeight":"600"
							}
						},
					},
				},
				"legend": {
					"common": {
						"itemName": {
							"style": {
								"fontSize": 10,
								"fill": "#000",
								"fontWeight":props?.showbtn && props?.showbtn === "0" ? "400" : "600"
							},
						},
					},
				},
			},
		},
		interactions: [{ type: 'element-active' },{ type: 'element-highlight-by-x' }],
		onReady:function(plot:any){
			plot.chart.removeInteraction('legend-filter');
			plot.on('mouseenter', (evt: any) => {
				// plot.update({
				// 	...config,
				// 	legend: false,
				// });
			});
		},
		onEvent:function(chart:any, event:any){
			// console.log("event",chart,event)
		},
		state: {
			// 设置 active 激活状态的样式
			active: {
				style: {
					stroke: '#000',
				},
			},
		},
		height:180,
		// minColumnWidth: 80,
    	// maxColumnWidth: 80,
	};

	return <Column {...config} />;
};

export default React.memo(CustomBarChart);